var chunkToChildrenMap = {
	"src_Bootstrap_tsx-src_app_components_HyperArcOverlayContext_tsx": [
		"src_app_home_Chrome_tsx"
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));